import {Pipe, PipeTransform} from '@angular/core';
import {AbstractControl, FormGroup} from "@angular/forms";

@Pipe({
    name: 'translationTabValidationClass',
    pure: false,
    standalone: false
})
export class TranslationTabValidationClassPipe implements PipeTransform {

    transform(translationControl: FormGroup, controlNames: string[] = []): string {

        let valid: boolean;

        if(Boolean(controlNames.length)){

            const controls: AbstractControl[] = [];

            controlNames.forEach((controlName: string): void => {

                if(translationControl.get(controlName) && (translationControl.get(controlName).status !== 'DISABLED')){

                    controls.push(translationControl.get(controlName));
                }
            });

            valid = controls.every((control: AbstractControl): boolean => {

                return control.valid;
            });
        }
        else {

            valid = translationControl.valid;
        }

        return valid ? 'translation-tab-valid' : 'translation-tab-invalid';
    }
}
